import { init } from '@elastic/apm-rum';

init({
  active: true,
  serverUrl: '/api/apm',
  serviceName: 'module-documents',
  serviceVersion: window?.env?.version,
  environment: window?.env?.stage,
});

import(/* webpackChunkName: "SimpleUploadShell" */ './src/shells/SimpleUploadShell.tsx');
